import { render, staticRenderFns } from "./DocumentsCreate.vue?vue&type=template&id=732673ab&scoped=true"
import script from "./DocumentsCreate.vue?vue&type=script&lang=js"
export * from "./DocumentsCreate.vue?vue&type=script&lang=js"
import style0 from "./DocumentsCreate.vue?vue&type=style&index=0&id=732673ab&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732673ab",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2296946445/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('732673ab')) {
      api.createRecord('732673ab', component.options)
    } else {
      api.reload('732673ab', component.options)
    }
    module.hot.accept("./DocumentsCreate.vue?vue&type=template&id=732673ab&scoped=true", function () {
      api.rerender('732673ab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/documents/views/DocumentsCreate.vue"
export default component.exports